(function () {
  PaymentController.$inject = ["API_URL", "$http", "$location", "$filter", "$rootScope"];
  angular.module('calendarApp').controller('PaymentController', PaymentController);

  function PaymentController(API_URL, $http, $location, $filter, $rootScope) {
    var pay = this;

    pay.init = function () {
      localStorage.removeItem('confirmed-appointments'); // Get appointments and payment info from storage

      var appointments = localStorage.getItem('reserved-appointments'),
          paymentState = localStorage.getItem('payment-state');

      if (!appointments || !paymentState) {
        $location.path('/');
        return;
      }

      pay.paymentState = JSON.parse(paymentState);
      pay.appointments = JSON.parse(appointments);
      pay.currencySettings = smooth.currencySettings;
    };

    pay.init();

    pay.noChargeContinue = function () {
      var appointmentids = pay.appointments.map(function (appointment) {
        return appointment._id;
      });
      $rootScope.throbber.show();
      $http.post(API_URL + '/stripe/submitpayment', {
        paymentstate: pay.paymentState,
        appointmentids: appointmentids
      }).then(function (reply) {
        $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          $rootScope.throbber.showError(response.msg);
          return;
        }

        pay.success(response.appointments);
      }, function (error) {
        console.error(error);
      });
    }; // Called from Stripe payments directive


    pay.success = function (newAppointments) {
      // Update localStorage
      localStorage.removeItem('reserved-appointments');
      localStorage.setItem('new-appointments', JSON.stringify(newAppointments));
      $location.path('/confirm');
    };

    pay.toggleReview = function () {
      $('.pay-appointment-review').slideToggle();
    };

    pay.cancel = function () {
      var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

      if (!confirm(cancelMessage)) {
        return;
      }

      $location.path('/');
    };
  }
})();